var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBreadcrumbs)?_c('div',[_c('breadcrumb-vue',{attrs:{"breadcrumbs":_vm.breadcrumbs}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }